import React, { useState, useEffect } from "react"
import Select from "react-select"
// Not sure why this is required but removing this breaks the styles.
import styled from "styled-components/macro"
import { ThemeProvider } from "styled-components"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Sidebar from "../components/sidebar"
import Item from "../components/item"
import ItemExpanded from "../components/ItemExpanded"
import {
  HeaderTitle,
  HeaderSubTitle,
  ViewColumn,
  ViewRow,
  FilterSelector,
  GlobalStyle,
  Option,
  OptionImg,
  TabLabel,
  ButtonGroup,
  Tab,
} from "../components/styled/styles"
import banners from "../constants/banners"
import weapons from "../constants/weapons"
import { lightTheme, darkTheme } from "./themes"
import Toggle from "./Toggle"

const types = ["Primary", "Heavy"]

export default props => {
  const [theme, setTheme] = useState("light")
  const setMode = mode => {
    window.localStorage.setItem("theme", mode)
    setTheme(mode)
  }
  const themeToggler = () => {
    theme === "light" ? setMode("dark") : setMode("light")
  }
  const [active, setActive] = useState(types[0])
  const [expanded, setExpanded] = useState(false)
  const [currentItem, setCurrentItem] = useState(false)
  const [selectedBanner, setSelectedBanner] = useState(undefined)
  function handleClick(expanded, ability) {
    setExpanded(expanded)
    setCurrentItem(ability)
  }
  useEffect(() => {
    const localTheme = window.localStorage.getItem("theme")
    localTheme && setTheme(localTheme)
  }, [])
  return (
    <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
      <Layout expanded={expanded} theme={theme === "light" ? lightTheme : darkTheme}>
        <SEO title="Weapons" />
        <React.Fragment>
          <GlobalStyle theme={theme === "light" ? lightTheme : darkTheme} />
          <ViewRow
            css={`
              width: 100%;
            `}
          >
            {/** Side bar */}
            <Sidebar expanded={expanded} theme={theme === "light" ? lightTheme : darkTheme} />
            {/** Right side */}
            <ViewRow>
              <ViewColumn>
                <ViewColumn
                  css={`
                    margin: 0 0 48px 24px;
                  `}
                >
                  <ViewRow
                    css={`
                      justify-content: space-between;
                      align-items: center;
                    `}
                  >
                    <ViewColumn>
                      <HeaderTitle theme={theme === "light" ? lightTheme : darkTheme}>CATALYST BLACK WIKI</HeaderTitle>
                      <HeaderSubTitle theme={theme === "light" ? lightTheme : darkTheme}>Weapons</HeaderSubTitle>
                    </ViewColumn>
                    <ViewRow onClick={themeToggler}>
                      <Toggle theme={theme === "light" ? lightTheme : darkTheme} toggleTheme={themeToggler} />
                    </ViewRow>
                  </ViewRow>
                  <ViewRow
                    css={`
                      margin-top: 32px;
                      align-items: center;
                      flex-wrap: wrap;
                      justify-content: space-between;
                    `}
                  >
                    <ButtonGroup theme={theme === "light" ? lightTheme : darkTheme}>
                      {types.map(type => (
                        <Tab
                          theme={theme === "light" ? lightTheme : darkTheme}
                          key={type}
                          active={active === type}
                          onClick={() => setActive(type)}
                        >
                          <TabLabel>{type}</TabLabel>
                        </Tab>
                      ))}
                    </ButtonGroup>

                    <FilterSelector>
                      <Select
                        classNamePrefix="control-prefix"
                        isClearable
                        options={banners.map(b => ({
                          name: b.name,
                          label: (
                            <Option>
                              <OptionImg
                                src={require(`../images/Banners/${b.name.toLowerCase().replace(/ /g, "")}.png`)}
                                height="auto"
                                width="30px"
                              />{" "}
                              {b.name}{" "}
                            </Option>
                          ),
                        }))}
                        onChange={a => setSelectedBanner(a && selectedBanner !== a.name ? a.name : undefined)}
                      />
                    </FilterSelector>
                  </ViewRow>
                </ViewColumn>
                <ViewRow>
                  <ViewRow
                    css={`
                      max-width: 1104px;
                      height: fit-content;
                      flex-wrap: wrap;
                      margin-right: 16px;
                    `}
                  >
                    {weapons
                      .filter(w => w.type === active)
                      .sort((a, b) => {
                        const textA = a.name.toUpperCase()
                        const textB = b.name.toUpperCase()
                        return textA < textB ? -1 : textA > textB ? 1 : 0
                      })
                      .map((item, index) =>
                        !selectedBanner || item.banner === selectedBanner ? (
                          <ViewColumn
                            onClick={() =>
                              handleClick(expanded === index ? false : index, currentItem === index ? null : item)
                            }
                            onKeyDown={() =>
                              handleClick(expanded === index ? false : index, currentItem === index ? null : item)
                            }
                            key={index}
                            css={`
                              flex: 1;
                              min-width: 230px;
                            `}
                          >
                            <Item
                              mask={props.mask}
                              theme={theme === "light" ? lightTheme : darkTheme}
                              data={item}
                              key={index}
                            />
                          </ViewColumn>
                        ) : null
                      )}
                  </ViewRow>
                  <ViewColumn>
                    {expanded !== false && (
                      <ItemExpanded
                        type="Weapons"
                        theme={theme === "light" ? lightTheme : darkTheme}
                        data={currentItem}
                        setExpanded={setExpanded}
                      />
                    )}
                  </ViewColumn>
                </ViewRow>
              </ViewColumn>
            </ViewRow>
          </ViewRow>
        </React.Fragment>
      </Layout>
    </ThemeProvider>
  )
}
